export default "__VITE_ASSET__Di9w_q5N__"